import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Grid,
  Toolbar,
  InputAdornment,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { MdOutlineDelete, MdOutlineEdit, MdAdd } from "react-icons/md";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import Layout from "../../components/layout/Layout";
import Admin from "../../components/auth/Admin";
import UserAction from "../../actions/User";
import { API } from "../../config";
import Controls from "../../components/controls/Controls";
import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Loading from "../../components/customHelpers/Loading";
import Norecords from "../../components/customHelpers/Norecords";
import { useMediaQuery, useTheme } from "@material-ui/core";


const headCells = [
  { id: "firstName", label: "First Name" },
  { id: "lastName", label: "Last Name" },
  { id: "email", label: "Email" },
  { id: "username", label: "Username" },
  { id: "role", label: "Role" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const Users = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewStaffs, deleteStaff, createStaff, updateRole } = UserAction();

  const [values, setValues] = useState({
    loading: false,
    staffs: [],
    reload: false,
  });
  const { loading, staffs, reload } = values;
  const [roles, setRoles] = useState([]);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [newStaff, setNewStaff] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    username: "",
    password: "",
    roleId: "",
  });
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [newRoleId, setNewRoleId] = useState("");

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => items,
  });

  useEffect(() => {
    getStaffs();
    getRoles();
  }, [reload]);

  const getStaffs = () => {
    setValues({ ...values, loading: true });
    viewStaffs().then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
        setValues({ ...values, loading: false });
      } else {
        setValues({
          ...values,
          staffs: data.data || [],
          loading: false,
        });
      }
    });
  };

  const getRoles = () => {
    fetch(`${API}/roles`)
      .then((res) => res.json())
      .then((data) => setRoles(data.data || []));
  };

  const handleCreateStaff = (e) => {
    e.preventDefault();
    createStaff(newStaff).then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else {
        NotifyMessage({ message: data.message, type: "success" });
        setOpen(false);
        setValues({ ...values, reload: !reload });
        setNewStaff({ firstName: "", lastName: "", email: "", phone: "", username: "", password: "", roleId: "" });
      }
    });
  };

  const handleUpdateRole = (e) => {
    e.preventDefault();
    updateRole(selectedStaff.Id, newRoleId).then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else {
        NotifyMessage({ message: data.message, type: "success" });
        setEditOpen(false);
        setValues({ ...values, reload: !reload });
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    deleteStaff(Id).then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else {
        NotifyMessage({ message: data.message, type: "success" });
        setValues({ ...values, reload: !reload });
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(staffs, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter(
            (x) =>
              x.firstName?.toLowerCase().includes(target.value.toLowerCase()) ||
              x.lastName?.toLowerCase().includes(target.value.toLowerCase()) ||
              x.email?.toLowerCase().includes(target.value.toLowerCase())
          );
      },
    });
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Staff Management
          </Typography>

          <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
            <Controls.Input
              label="Search Staff"
              className="searchInput"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
            <Button
              variant="contained"
              color="primary"
              startIcon={<MdAdd />}
              onClick={() => setOpen(true)}
            >
              Create User
            </Button>
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.Id}>
                            <TableCell>{item.firstName}</TableCell>
                            <TableCell>{item.lastName}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.username}</TableCell>
                            <TableCell>
                              {item.assignedRole ? item.assignedRole.name : "No Role"}
                            </TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="primary"
                                title="Edit Role"
                                onClick={() => {
                                  setSelectedStaff(item);
                                  setNewRoleId(item.roleId || "");
                                  setEditOpen(true);
                                }}
                              >
                                <MdOutlineEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="secondary"
                                title="Delete"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title: "Are you sure to delete this user?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => onDelete(item.Id),
                                  });
                                }}
                              >
                                <MdOutlineDelete fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </>
              )}
            </Grid>
          </Grid>

          {/* Create User Dialog */}
          <Dialog open={open} onClose={() => setOpen(false)} fullScreen={isMobile}>
            <form onSubmit={handleCreateStaff}>
              <DialogTitle>Create New Staff User</DialogTitle>
              <DialogContent>
                <TextField
                  label="First Name"
                  fullWidth
                  margin="dense"
                  required
                  value={newStaff.firstName}
                  onChange={(e) => setNewStaff({ ...newStaff, firstName: e.target.value })}
                />
                <TextField
                  label="Last Name"
                  fullWidth
                  margin="dense"
                  value={newStaff.lastName}
                  onChange={(e) => setNewStaff({ ...newStaff, lastName: e.target.value })}
                />
                <TextField
                  label="Email"
                  fullWidth
                  margin="dense"
                  required
                  type="email"
                  value={newStaff.email}
                  onChange={(e) => setNewStaff({ ...newStaff, email: e.target.value })}
                />
                <TextField
                  label="Username"
                  fullWidth
                  margin="dense"
                  required
                  value={newStaff.username}
                  onChange={(e) => setNewStaff({ ...newStaff, username: e.target.value })}
                />
                <TextField
                  label="Password"
                  fullWidth
                  margin="dense"
                  required
                  type="password"
                  value={newStaff.password}
                  onChange={(e) => setNewStaff({ ...newStaff, password: e.target.value })}
                />
                <FormControl fullWidth margin="dense">
                  <InputLabel>Role</InputLabel>
                  <Select
                    value={newStaff.roleId}
                    onChange={(e) => setNewStaff({ ...newStaff, roleId: e.target.value })}
                    required
                  >
                    {roles.map((role) => (
                      <MenuItem key={role.id} value={role.id}>
                        {role.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button type="submit" color="primary" variant="contained">
                  Create
                </Button>
              </DialogActions>
            </form>
          </Dialog>

          {/* Edit Role Dialog */}
          <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullScreen={isMobile}>
            <form onSubmit={handleUpdateRole}>
              <DialogTitle>Edit User Role</DialogTitle>
              <DialogContent style={{ minWidth: 300 }}>
                <Typography variant="body1">
                  User: {selectedStaff?.firstName} {selectedStaff?.lastName}
                </Typography>
                <FormControl fullWidth margin="normal">
                  <InputLabel>New Role</InputLabel>
                  <Select
                    value={newRoleId}
                    onChange={(e) => setNewRoleId(e.target.value)}
                    required
                  >
                    {roles.map((role) => (
                      <MenuItem key={role.id} value={role.id}>
                        {role.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setEditOpen(false)}>Cancel</Button>
                <Button type="submit" color="primary" variant="contained">
                  Update Role
                </Button>
              </DialogActions>
            </form>
          </Dialog>

          <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
      </Admin>
    </Layout>
  );
};

export default Users;
